import type { IIntegrationFormData } from "src/integrations/forms/IIntegrationFormData";
import {
  type IIntegrationFormDataShopify,
  integrationDataToIntegrationShopify,
  integrationToIntegrationDataShopify,
} from "src/integrations/forms/shopify/IIntegrationFormDataShopify";
import type { IntegrationShopify } from "src/integrations/objects/IntegrationShopify";
import type { IntegrationType } from "src/integrations/objects/IntegrationType";

export const INTEGRATION_SHOPIFY_META_OBJECT_TYPE = "metaobjectType";

export interface IIntegrationFormDataShopifyForm
  extends IIntegrationFormDataShopify {
  [INTEGRATION_SHOPIFY_META_OBJECT_TYPE]: string;
}

export function integrationDataToIntegrationShopifyForm(
  integrationType: IntegrationType,
  integrationData: Partial<IIntegrationFormData>,
  integrationUuid?: string,
): Partial<IntegrationShopify> {
  return {
    ...integrationDataToIntegrationShopify(
      integrationType,
      integrationData,
      integrationUuid,
    ),
    metaobjectType: integrationData[INTEGRATION_SHOPIFY_META_OBJECT_TYPE],
  };
}

export function integrationToIntegrationDataShopifyForm(
  integrationType: IntegrationType,
  integration: IntegrationShopify,
): Partial<IIntegrationFormDataShopifyForm> {
  return {
    ...integrationToIntegrationDataShopify(integrationType, integration),
    [INTEGRATION_SHOPIFY_META_OBJECT_TYPE]: integration.metaobjectType,
  };
}
